import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    profile_settings_header_text: {
      id: 'profile_settings_header_text',
      defaultMessage: "Profile settings",
      description: '',
    },
    device_list_header_text: {
      id: 'device_list_header_text',
      defaultMessage: "Devices list",
      description: '',
    },
    logout_header_text: {
      id: 'logout_header_text',
      defaultMessage: "Logout",
      description: '',
    },
    add_new_device_submit_main_screen_text: {
      id: 'add_new_device_submit_main_screen_text',
      defaultMessage: "Add",
      description: '',
    },
    basic_navigation_notifications: {
      id: 'basic_navigation_notifications',
      defaultMessage: "Notifications",
      description: '',
    },
    basic_navigation_messages: {
      id: 'basic_navigation_messages',
      defaultMessage: "Messages",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/BasicNavigation/Messages.js